import { ViewColumn } from 'common/types/viewColumn';
import { ExtraOptions } from '../types';
import { map, each, isNil, keyBy, get, isObject } from 'lodash';
import { Row } from './type';
import {
  agGridDataFormatter,
  isEmailType
} from 'common/visualizations/views/agGridReact/helpers/TableColumnFormatting';
import { GridApi, ICellRendererParams } from '@ag-grid-community/core';
import { isUrlColumnType } from 'common/visualizations/helpers/CalendarHelper';

interface FormatRowDataArgs {
  rowData: Row[];
  gridApi: GridApi;
  columns: ViewColumn[];
  extraOptions: ExtraOptions;
}

// Tried doing it in the print preview worker. But the DataTypeFormatter requires
// jQuery and i18n. So for now, formatting the table cell content in the main thread.
// Later: Probably, we can create a generic DataTypeFormatter that takes
// sanitizeHTML/currencySymbol as inputs.
// - original DataTypeFormatter will use jquery/I18n for sanitizeHTML/currencySymbol
// - web worker DataTypeFormatter where we will pass a new sanitizeHTML and pass
//  currencySymbol to webWorker from mainThread
export const formatRows = ({ rowData, columns, extraOptions, gridApi }: FormatRowDataArgs) => {
  const { dataset, nonStandardAggregations, columnFormats } = extraOptions;
  const allDisplayedColumns = gridApi.getAllDisplayedColumns();
  const rowGroupCols = gridApi.getRowGroupColumns();
  const columnsById = keyBy(allDisplayedColumns.concat(rowGroupCols), (col: any) => col.getColId());

  return map(rowData, (rowDatum: Row & any) => {
    const newRowDatum: any = { ...rowDatum };

    each(columns, (columnItem) => {
      const value = rowDatum[columnItem.fieldName!];
      const columnDef = get(columnsById, [columnItem.fieldName, 'colDef']);
      const newColumnParams: ICellRendererParams = {
        ...columnDef,
        colDef: columnDef,
        value,
        valueFormatted: value
      };
      const isTextColumn = columnItem.renderTypeName === 'text';
      const isUrlColumn = isUrlColumnType(columnItem.fieldName, columns);
      const isEmailColumn = isEmailType(columnItem.fieldName, columns);

      if (!isNil(value)) {
        const formattedValue =
          isUrlColumn || isEmailColumn
            ? formatUrlValue(value)
            : agGridDataFormatter(
                dataset.domain,
                dataset.datasetUid,
                columns,
                nonStandardAggregations,
                newColumnParams,
                columnFormats
              );
        newRowDatum[columnItem.fieldName!] = isTextColumn
          ? decodeHtmlEntities(formattedValue)
          : formattedValue;
      }
    });

    return newRowDatum;
  });
};

interface URLValue {
  url: string;
}
const formatUrlValue = (value: URLValue | string) => {
  return isObject(value) ? value.url : value;
};

const decodeHtmlEntities = (text: string) => {
  const div = document.createElement('div');
  div.innerHTML = text;
  return div.textContent || div.innerText;
};
